export const KEY_GET_ASPECT = 'get.aspect.call';
export const KEY_GET_ASPECT_FOR_APP = 'get.aspect-for-app.call';
export const KEY_POST_ASPECT_GENERATE = 'post.aspect-generate.call';
export const KEY_POST_ASPECT_CREATE = 'post.aspect-create.call';
export const KEY_PUT_ASPECT_SAVE = 'put.aspect-save.call';
export const KEY_GET_ASPECT_COLORS = 'get.aspect-colors.call';
